/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { SharedState } from "./SharedState";
import { SharedStateStore } from "./store/SharedStateStore";

/**
 * Gets the shared state that can be used by any experiences.
 * @returns The shared state that can be used by any experiences.
 */
export const getSharedState = (): SharedState => {
    return SharedStateStore();
};
